export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_01.77a204ee.jpg";